import { Group } from '@mantine/core';
import { Fragment } from 'react';
import { DateInputWithLabel } from 'src/design-system/DateInputWithLabel';
import { InputWithLabel } from 'src/design-system/InputWithLabel';
import { Select } from 'src/design-system/Select';

type SharedFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
};

export type CashflowField =
  | (SharedFieldProps & {
      kind: 'select';
      data: readonly { value: string; label: string }[];
      placeholder?: string;
      searchable?: boolean;
      error?: string;
    })
  | (SharedFieldProps & { kind: 'date' })
  | (SharedFieldProps & { kind: 'text' });

/** Each row is laid out side by side; a row of one spans the pane. */
export function CashflowFields({ rows }: { rows: CashflowField[][] }) {
  return (
    <>
      {rows.map((row, index) => (
        <Group key={index} grow align="flex-start">
          {row.map(field => (
            <Fragment key={field.label}>
              {field.kind === 'select' && (
                <Select
                  label={field.label}
                  data={field.data as { value: string; label: string }[]}
                  value={field.value}
                  onChange={value => field.onChange(value ?? '')}
                  placeholder={field.placeholder}
                  required={field.required}
                  disabled={field.disabled}
                  searchable={field.searchable}
                  error={field.error}
                  allowDeselect={false}
                />
              )}
              {field.kind === 'date' && (
                <DateInputWithLabel
                  label={field.label}
                  value={field.value || null}
                  onChange={value => field.onChange(value ?? '')}
                  placeholder="DD/MM/YYYY"
                  required={field.required}
                  disabled={field.disabled}
                />
              )}
              {field.kind === 'text' && (
                <InputWithLabel
                  label={field.label}
                  value={field.value}
                  onChange={event => field.onChange(event.currentTarget.value)}
                  required={field.required}
                  disabled={field.disabled}
                />
              )}
            </Fragment>
          ))}
        </Group>
      ))}
    </>
  );
}
